import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { debugHistory } from "../navigation/debug";
import { canGoBackInsideApp } from "../navigation/history";
import { getBackTarget, PAYMENT_BACK_EVENT, shouldShowTelegramBackButton } from "../navigation/routes";

export default function NavigationController() {
    const location = useLocation();
    const navigate = useNavigate();

    React.useEffect(() => {
        const pathname = location.pathname;
        const telegramBackButton = window.Telegram?.WebApp?.BackButton;
        const isPaymentPage = pathname === "/payment";
        const backTarget = getBackTarget(pathname);
        const shouldShowTelegramBack = shouldShowTelegramBackButton(pathname);

        debugHistory("NavigationController", "effect:start", {
            pathname,
            isPaymentPage,
            backTarget,
            shouldShowTelegramBack,
            canGoBackInsideApp: canGoBackInsideApp(),
        });

        const handleBack = () => {
            debugHistory("NavigationController", "telegram-back:click", {
                pathname,
                isPaymentPage,
                backTarget,
                canGoBackInsideApp: canGoBackInsideApp(),
            });

            if (isPaymentPage) {
                window.dispatchEvent(new CustomEvent(PAYMENT_BACK_EVENT));
                return;
            }

            if (canGoBackInsideApp()) {
                navigate(-1);
                return;
            }

            if (backTarget) {
                navigate(backTarget, { replace: true });
                return;
            }

            if (pathname !== "/") {
                navigate("/", { replace: true });
            }
        };

        if (!telegramBackButton) {
            debugHistory("NavigationController", "effect:no-telegram-back-button", { pathname });
            return undefined;
        }

        if (shouldShowTelegramBack) {
            telegramBackButton.show();
        } else {
            telegramBackButton.hide();
        }

        telegramBackButton.onClick(handleBack);

        return () => {
            debugHistory("NavigationController", "effect:cleanup", { pathname });
            telegramBackButton.offClick?.(handleBack);
        };
    }, [location.pathname, navigate]);

    return null;
}
